import React from 'react';
import CardLogin from 'app/components/Layouts/CardLogin';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Typography,
} from '@mui/material';
import {
  btnBox,
  descText,
  infoText,
  inputInfo,
  modalBoxContent,
  modalBoxDesc,
  modalBoxPaper,
  modalBoxText,
} from './NewPass.sx';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import {grey, red2} from 'app/components/ThemeProvider/colors';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import useNewPass from 'app/pages/Authorization/NewPass/useNewPass';
import BackButton from 'app/components/BackButton';
import SuccessIcon from 'app/components/Icons/SuccessIcon';
import CustomSnackbar from 'app/components/CustomSnackbar';
import FieldError from "app/components/FieldError";
import {FieldErrors} from "react-hook-form";

function NewPass() {
  const {
    t,
    isLoadingRecovery,
    password,
    showPassword,
    showModal,
    handleChangePassword,
    handleSubmitForm,
    handleClickShowPassword,
    handleMouseDownPassword,
    checkPassword,
    handleChangeCheckPassword,
    handleClickShowCheckPassword,
    showCheckPassword,
    handleMouseDownCheckPassword,
    setOpenSnackbar,
    openSnackbar,
    dataRecovery,
  } = useNewPass();





  return (
    <CardLogin>
      <Typography sx={infoText}>{t('recovery.newPassSet')}</Typography>
      <Typography sx={descText}>{t('recovery.newPassDesc')}</Typography>
      <form
        style={{
          position: 'relative',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
        onSubmit={handleSubmitForm}
      >
        <Box>
          <Box>
            <Typography sx={inputInfo}>{t('recovery.newPass')}</Typography>
            <OutlinedInput
              type={showPassword ? 'text' : 'password'}
              placeholder={t('recovery.newPassAdd')}
              sx={{
                width: '100%',
                mb: '24px',
                pl: '16px',

                '@media screen and (max-height: 864px)': {
                  mb: '20px',
                },
              }}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end">
                    {showPassword ? (
                      <VisibilityOffOutlinedIcon style={{ color: grey }} />
                    ) : (
                      <VisibilityOutlinedIcon style={{ color: grey }} />
                    )}
                  </IconButton>
                </InputAdornment>
              }
              inputProps={{
                style: { paddingLeft: '0' },
              }}
              onChange={handleChangePassword}
              value={password}
            />
          </Box>
          <Box>
            <Typography sx={inputInfo}>{t('recovery.newPassRepeat')}</Typography>
            <OutlinedInput
              type={showCheckPassword ? 'text' : 'password'}
              placeholder={t('recovery.newPassRepeat')}
              sx={{
                width: '100%',
                mb: '0px',
                pl: '16px',
                '@media screen and (max-height: 864px)': {
                  mb: '0px',
                },
              }}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowCheckPassword}
                    onMouseDown={handleMouseDownCheckPassword}
                    edge="end"
                  >
                    {showCheckPassword ? (
                      <VisibilityOffOutlinedIcon style={{ color: grey }} />
                    ) : (
                      <VisibilityOutlinedIcon style={{ color: grey }} />
                    )}
                  </IconButton>
                </InputAdornment>
              }
              error={(password.length > 0 && password !== checkPassword && checkPassword.length > 0)}
              inputProps={{
                style: { paddingLeft: '0' },
              }}
              onChange={handleChangeCheckPassword}
              value={checkPassword}
            />
              <FieldError
                  error={(password.length > 0 && password !== checkPassword && checkPassword.length > 0) || isLoadingRecovery ? {message: "Daxil etdiyiniz şifrələr uyğunlaşmır"} : undefined}
              />
          </Box>
        </Box>
        <Box sx={btnBox}>
          <Button
            type={'submit'}
            disabled={!(password.length > 0 && password === checkPassword) || isLoadingRecovery}
            variant={'contained'}
            sx={{ mb: '12px' }}
          >
            {t('recovery.continue')}
          </Button>

          <BackButton text={'recovery.back'} />
        </Box>
      </form>
      {showModal && (
        <Dialog
          open={showModal}
          onClose={(event: any) => {
            event.stopPropagation();
          }}
          PaperProps={{
            sx: modalBoxPaper,
          }}
        >
          <DialogContent sx={modalBoxContent}>
            <SuccessIcon sx={{ mb: '42px' }} />
            <Typography sx={modalBoxText}>{t('recovery.changePass')}</Typography>
            <Typography sx={modalBoxDesc}>{t('recovery.changePassDesc')}</Typography>
          </DialogContent>
          <DialogActions sx={{ p: 0 }}>
            <Button
              sx={{ width: '100%' }}
              onClick={() => {
                window.location.href = '/az/login';
              }}
            >
              Daxil ol
            </Button>
          </DialogActions>
        </Dialog>
      )}
      <CustomSnackbar
        open={openSnackbar}
        setOpen={setOpenSnackbar}
        hideDuration={5000}
        type={'error'}
        text={dataRecovery?.text}
      />
    </CardLogin>
  );
}

export default NewPass;
